import React, { useState, useEffect } from 'react';
import { Button, Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';
import DocumentTypes from '../common/LookupDropDown';

const DocumentModal = (props) => {
    const [documentTypeId, setDocumentTypeId] = useState(props.documentTypeId);
    useEffect(() => setDocumentTypeId(props.documentTypeId), [props.documentTypeId]);

    const handleOnSave = () => {
        props.onSave(documentTypeId);
        props.onToggle();
    }

    const handleTypeChange = (e) => setDocumentTypeId(e.target.value);

    return (
        <Modal
            isOpen={props.isOpen}
            toggle={props.onToggle}
            size='lg'
        >
            <ModalHeader>Edit Document</ModalHeader>
            <ModalBody>

                <DocumentTypes
                    label='Document Type'
                    name={'documentTypeId'}
                    value={documentTypeId}
                    lookups={props.documentTypes}
                    onChange={handleTypeChange}
                />

            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={handleOnSave}>OK</Button>{' '}
                <Button color="secondary" onClick={props.onToggle}>Cancel</Button>
            </ModalFooter>
        </Modal>
    );
}

export default DocumentModal